import BoltIcon from '@mui/icons-material/Bolt';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';

export const getAnalysisTypeIcon = (analysisType) => {
  switch (analysisType) {
    case 'power':
      return <BoltIcon />;
    case 'water':
      return <WaterDropRoundedIcon />;
    case 'heat':
      return <LocalFireDepartmentRoundedIcon />;
    default:
      return <QuestionMarkRoundedIcon />;
  }
};
